import { UnreachableCaseError } from 'ts-essentials';
import { ICreatableNode, IEntityNode, IInlineBranchNode } from '../types';
import VirtualEventDetails from './VirtualEventDetails';
import BasicEventDetails from './BasicEventDetails';
import CohortDetails from './CohortDetails';
import AnyTableEventDetails from './AnyTableEventDetails';
import FieldDetails from './FieldDetails';
import NamedFilterDetails from './NamedFilterDetails';
import MeasureDetails from './MeasureDetails';
import BucketDefDetails from './BucketDefDetails';
import CustomBinningDetails from './CustomBinningDetails';
import { useEffect } from 'react';
import { usePanelStateContext } from '../context';

interface IProps {
  node: IEntityNode | ICreatableNode | IInlineBranchNode;
}

const EntityDetails = ({ node }: IProps) => {
  const { getEntityFromCacheOrFetch } = usePanelStateContext();

  useEffect(() => {
    // noinspection JSIgnoredPromiseFromCall
    getEntityFromCacheOrFetch(node);
  }, [getEntityFromCacheOrFetch, node]);

  if (node.__typename === 'TagLeafBasicEvent') {
    return <BasicEventDetails node={node} />;
  } else if (node.__typename === 'TagLeafVirtualEvent') {
    return <VirtualEventDetails node={node} />;
  } else if (node.__typename === 'TagLeafAnyEvent') {
    throw new Error('Unsupported type: ' + node.__typename);
  } else if (node.__typename === 'TagLeafAnyTableEvent') {
    return <AnyTableEventDetails node={node} />;
  } else if (
    node.__typename === 'TagLeafCompoundCohort' ||
    node.__typename === 'TagLeafSimpleCohort'
  ) {
    return <CohortDetails node={node} />;
  } else if (
    node.__typename === 'TagLeafField' ||
    node.__typename === 'TagFieldInlineBranch' ||
    node.__typename === 'TagInlineBranch'
  ) {
    return <FieldDetails node={node} />;
  } else if (node.__typename === 'TagLeafFilter') {
    return <NamedFilterDetails node={node} />;
  } else if (
    node.__typename === 'TagLeafCompoundMeasure' ||
    node.__typename === 'TagLeafSimpleMeasure'
  ) {
    return <MeasureDetails node={node} />;
  } else if (
    node.__typename === 'TagLeafDateBucketDef' ||
    node.__typename === 'TagLeafRangeBucketDef' ||
    node.__typename === 'TagLeafEnumBucketDef'
  ) {
    return <BucketDefDetails node={node} />;
  } else if (node.__typename === 'TagLeafCustomBucketDef') {
    return <CustomBinningDetails node={node} />;
  } else if (node.__typename === '__CreatableNode') {
    throw new Error('Unsupported type: ' + node.__typename);
  } else {
    throw new UnreachableCaseError(node);
  }
};
export default EntityDetails;
